import { gql, NetworkStatus, useQuery } from "@apollo/client";
import { shiftStreamClient } from "../../../graphql/client";

export const PAGE_SIZE = 50;

export const GET_EMAILS = gql`
  query getEmails($ids: [Int]!) {
    emails(ids: $ids, offset: 0, limit: 1) {
      data {
        id
        sender
        mailboxAddress
        streamIds
        receivedAt
      }
    }
  }
`;

export const useEmail = ({ id }: { id: number | null | undefined }) => {
  const { data, loading, networkStatus } = useQuery(GET_EMAILS, {
    client: shiftStreamClient,
    variables: {
      ids: id !== null ? [id] : []
    },
    skip: !id,
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    onError: error => {
      throw error;
    }
  });

  // Keep pagination metadata stable while the next page is loading.
  const resolvedData = data;

  return {
    loading: loading || networkStatus === NetworkStatus.refetch,
    email: resolvedData?.emails?.data?.[0] || null
  };
};
